export default {"src":"https://fishbrain.com/_next/static/media/newJersey.d5d00fca.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};